import './assets/less/bootstrap.less';

// React
import React from 'react';
import store from './store';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter, Route } from 'react-router-dom';

// Internationalization
import IntlSwapProvider from './components/providers/intlSwapProvider.component.jsx';
// RouteIdentifier
import RouterProvider from './components/providers/routerProvider.component.jsx';

// Main Component
import Main from './components/core/main.component.jsx';

function appRender() {
  return (
    render(
      <Provider store={store}>
        <BrowserRouter>
          <RouterProvider>
            <IntlSwapProvider>
              <Route component={Main}/>
            </IntlSwapProvider>
          </RouterProvider>
        </BrowserRouter>
      </Provider>,
      document.getElementById('main-app')
    )
  )
}

if (!window.intl) {
	require.ensure([
		'intl',
		'intl/locale-data/jsonp/es.js',
		'intl/locale-data/jsonp/pt.js'
	], (require) => {
		require('intl');
		require('intl/locale-data/jsonp/es.js');
		require('intl/locale-data/jsonp/pt.js');
		appRender();
	});
} else {
	appRender();
}


// WEBPACK FOOTER //
// ./src/app.jsx